import { render, staticRenderFns } from "./list-partners.vue?vue&type=template&id=030cda02&scoped=true&"
import script from "./list-partners.vue?vue&type=script&lang=js&"
export * from "./list-partners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030cda02",
  null
  
)

export default component.exports